import Home from "./components/Home";
import EmpList from "./components/Employees/EmployeeList";
import EmpCreate from "./components/Employees/EmployeeCreate";
import EmpUpdate from "./components/Employees/EmployeeUpdate";
import EmpDelete from "./components/Employees/EmployeeDelete";
import EmpDetails from "./components/Employees/EmployeeDetails";
import OvertimeList from "./components/Overtime/OvertimeList";
import OTCreate from "./components/Overtime/OvertimeCreate";
import OTUpdate from "./components/Overtime/OvertimeUpdate";
import OTDetails from "./components/Overtime/OvertimeDetails";
import OTApproved from "./components/Overtime/OvertimeApproved";
import OTRejected from "./components/Overtime/OvertimeRejected";
import OTDelete from "./components/Overtime/OvertimeDelete";
import LeaveList from "./components/Leave/LeaveList";
import LeaveCreate from "./components/Leave/LeaveCreate";
import LeaveDetails from "./components/Leave/LeaveDetails";
import LeaveUpdate from "./components/Leave/LeaveUpdate";
import LeaveApproved from "./components/Leave/LeaveApproved";
import LeaveRejected from "./components/Leave/LeaveRejected";
import LeaveDelete from "./components/Leave/LeaveDelete";
import UndertimeList from "./components/Undertime/UndertimeList";
import UTCreate from "./components/Undertime/UndertimeCreate";
import UTUpdate from "./components/Undertime/UndertimeUpdate";
import UTDetails from "./components/Undertime/UndertimeDetails";
import UTApproved from "./components/Undertime/UndertimeApproved";
import UTRejected from "./components/Undertime/UndertimeRejected";
import UTDelete from "./components/Undertime/UndertimeDelete";
import TimeEntryList from "./components/TimeEntry/TimeEntryList";
import TimeEntryCreate from "./components/TimeEntry/TimeEntryCreate";
import TimeEntryDetails from "./components/TimeEntry/TimeEntryDetails";
import TimeEntryUpdate from "./components/TimeEntry/TimeEntryUpdated";
import TimeEntryDelete from "./components/TimeEntry/TimeEntryDelete";
import TimeEntryApproved from "./components/TimeEntry/TimeEntryApproved";
import TimeEntryRejected from "./components/TimeEntry/TimeEntryRejected";
import RVTransactions from "./components/ReportView/ReportViews";
import UsersList from "./components/Users/UserList";
import UserUpdateRole from "./components/Users/UserUpdateRole";


const AppRoutes = [
  {
    index: true,
    element: <Home />
  },
  {
    path: '/employee-list',
    element: <EmpList />
  },
  {
    path: '/employee-create',
    element: <EmpCreate />
  },
  {
    path: '/employee-update/:employeeId',
    element: <EmpUpdate />
  },
  {
    path: '/employee-view/:employeeId',
    element: <EmpDetails />
  },
  {
    path: '/employee-delete/:employeeId',
    element: <EmpDelete />
  },
  {
    path: '/overtime-list',
    element: <OvertimeList />
  },
  {
    path: '/overtime-create',
    element: <OTCreate />
  },
  {
    path: '/overtime-update/:overtimeId',
    element: <OTUpdate />
  },
  {
    path: '/overtime-view/:overtimeId',
    element: <OTDetails />
  },
  {
    path: '/overtime-approve/:overtimeId',
    element: <OTApproved />
  },
  {
    path: '/overtime-reject/:overtimeId',
    element: <OTRejected />
  },
  {
    path: '/overtime-delete/:overtimeId',
    element: <OTDelete />
  },
  {
    path: '/leave-list',
    element: <LeaveList />
  },
  {
    path: '/leave-create',
    element: <LeaveCreate />
  },
  {
    path: '/leave-view/:leaveId',
    element: <LeaveDetails />
  },
  {
    path: '/leave-update/:leaveId',
    element: <LeaveUpdate />
  },
  {
    path: '/leave-approve/:leaveId',
    element: <LeaveApproved />
  },
  {
    path: '/leave-reject/:leaveId',
    element: <LeaveRejected />
  },
  {
    path: '/leave-delete/:leaveId',
    element: <LeaveDelete />
  },
  {
    path: '/undertime-list',
    element: <UndertimeList />
  },
  {
    path: '/undertime-create',
    element: <UTCreate />
  },
  {
    path: '/undertime-update/:undertimeId',
    element: <UTUpdate />
  },
  {
    path: '/undertime-view/:undertimeId',
    element: <UTDetails />
  },
  {
    path: '/undertime-approve/:undertimeId',
    element: <UTApproved />
  },
  {
    path: '/undertime-reject/:undertimeId',
    element: <UTRejected />
  },
  {
    path: '/undertime-delete/:undertimeId',
    element: <UTDelete />
  },
  {
    path: '/timeentry-list',
    element: <TimeEntryList />
  },
  {
    path: '/timeentry-create',
    element: <TimeEntryCreate />
  },
  {
    path: '/timeentry-view/:timeEntryId',
    element: <TimeEntryDetails />
  },
  {
    path: '/timeentry-update/:timeEntryId',
    element: <TimeEntryUpdate />
  },
  {
    path: '/timeentry-delete/:timeEntryId',
    element: <TimeEntryDelete />
  },
  {
    path: '/timeentry-approve/:timeEntryId',
    element: <TimeEntryApproved />
  },
  {
    path: '/timeentry-reject/:timeEntryId',
    element: <TimeEntryRejected />
  },
  {
    path: '/reportviews',
    element: <RVTransactions />
  },
  {
    path: '/user-list',
    element: <UsersList />
  },
  {
    path: '/user-updaterole/:userId',
    element: <UserUpdateRole />
  }
];

export default AppRoutes;
